(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /* Feature 2: hover image panel swap — vanilla JS, no libraries */
  (function () {
    function initHoverImagePanels() {
      /* Wire each link that carries data-hover-img to its panel */
      document.querySelectorAll('[data-hover-img][data-hover-panel]').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          var panelId = link.dataset.hoverPanel;
          var panel = document.querySelector('[data-hover-panel-id="' + panelId + '"]');
          if (!panel) return;
          var img = panel.querySelector('.mega-menu__hover-panel-img');
          if (!img) return;
          var newSrc = link.dataset.hoverImg;
          if (!newSrc || img.src === newSrc) return;

          clearTimeout(img.__hoverTimer);
          img.style.opacity = '0';
          img.__hoverTimer = setTimeout(function () {
            img.src = newSrc;
            img.style.opacity = '1';
          }, 150);
        });
      });

      /* Reset to default image when the pointer leaves the submenu */
      document.querySelectorAll('[data-hover-panel-id]').forEach(function (panel) {
        var img = panel.querySelector('.mega-menu__hover-panel-img');
        if (!img) return;
        var defaultSrc = img.dataset.defaultSrc;
        if (!defaultSrc) return;

        var submenu = panel.closest('.menu-list__submenu');
        if (!submenu) return;

        submenu.addEventListener('mouseleave', function () {
          if (img.src === defaultSrc) return;
          clearTimeout(img.__hoverTimer);
          img.style.opacity = '0';
          img.__hoverTimer = setTimeout(function () {
            img.src = defaultSrc;
            img.style.opacity = '1';
          }, 150);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverImagePanels);
    } else {
      initHoverImagePanels();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
